import {
  SaveMetaInspection_Input,
  useSaveClientReportMetaInspectionMutation
} from 'generated/graphql';
import React from 'react';

export function useSaveClientReportEvent() {
  const [
    fnMutate,
    tuple
  ] = useSaveClientReportMetaInspectionMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = React.useCallback(
    async (input: SaveMetaInspection_Input) => {
      await fnMutate({
        variables: {
          input
        }
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
